import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "/static/fake-data/",
  headers: { "Content-type": "application/json; charset=utf-8" },
});

export default axiosInstance;
